import React, { useState } from "react";
import { Badge, Button, Card, Form, InputGroup, ListGroup, Spinner } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { AdminUserModel } from "../../models/AccountPermissionModel";
import Avatar from "../Avatar/Avatar";

interface IProps {
  accounts: AdminUserModel[];
  selectedUserId: string | null;
  selectedModeCount?: number; // 선택된 계정의 부여 모드 수 (목록 데이터엔 modes가 없어 별도로 받음)
  onSelect: (account: AdminUserModel) => void;
  onNew: () => void;
  isLoading?: boolean;
}

const AccountListBox = ({ accounts, selectedUserId, selectedModeCount, onSelect, onNew, isLoading }: IProps) => {
  const [search, setSearch] = useState("");
  const keyword = search.toLowerCase();
  const filtered = accounts.filter(
    (account) => (account.name ?? "").toLowerCase().includes(keyword) || account.email.toLowerCase().includes(keyword)
  );

  return (
    <Card className="shadow-sm h-100 d-flex flex-column">
      <Card.Header className="bg-white">
        <div className="d-flex align-items-center mb-2">
          <span className="fw-bold">계정 목록</span>
          <Badge bg="secondary" pill className="ms-2">{accounts.length}</Badge>
        </div>
        <InputGroup size="sm">
          <InputGroup.Text className="bg-white"><Search size={14} /></InputGroup.Text>
          <Form.Control
            placeholder="이름 · 아이디 검색"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
      </Card.Header>

      <ListGroup variant="flush" className="flex-grow-1" style={{ overflowY: "auto", minHeight: 0 }}>
        {isLoading && accounts.length === 0 && (
          <ListGroup.Item className="text-muted text-center small py-4">
            <Spinner animation="border" size="sm" className="me-2" />계정 불러오는 중…
          </ListGroup.Item>
        )}
        {filtered.map((account) => (
          <ListGroup.Item
            key={account.userId}
            action
            active={account.userId === selectedUserId}
            onClick={() => onSelect(account)}
            className="d-flex align-items-center gap-2"
            style={{ cursor: "pointer" }}
          >
            <Avatar name={account.name} />
            <span className="d-flex flex-column overflow-hidden">
              <span className="fw-semibold text-truncate">{account.name || "이름 없음"}</span>
              <small className={account.userId === selectedUserId ? "text-white-50" : "text-muted"} style={{ fontSize: 11 }}>
                {account.email}
              </small>
            </span>
            <span className="flex-grow-1" />
            {/* 모드 수는 선택해서 로드된 계정에만 표시 (전체 사전 로딩 없음) */}
            {account.userId === selectedUserId && (
              <Badge bg="light" text="dark" className="flex-shrink-0">{selectedModeCount ?? 0}모드</Badge>
            )}
          </ListGroup.Item>
        ))}
        {!isLoading && filtered.length === 0 && (
          <ListGroup.Item className="text-muted text-center small py-4">검색 결과 없음</ListGroup.Item>
        )}
      </ListGroup>

      <Card.Footer className="bg-white">
        <Button variant="primary" className="w-100" onClick={onNew}>새 계정 등록</Button>
      </Card.Footer>
    </Card>
  );
};

export default AccountListBox;
